import template from './switchRefix.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $mdDialog,
  $mdUtil,
  webpage,
  cookies,
  authenticationService,
  jsonFactory,
  eventService,
  helperService,
  accountService,
  uiService,
  Contact,
  contactService,
  contactsService,
  ticketService,
  ticketsService,
  workflowService,
  homeLoanService,
  lendersService,
  ReviewProductSplit,
  SwitchReviewProduct,
  SwitchCompareProduct
) => {
  $scope.Model = {
    hasBrokerToolsEnabled: $rootScope.hasBrokerToolsEnabled(),
    organizationCountry: helperService.getOrganizationCountry(),
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    currentHomeLoan: {},
    availableContacts: [],
    availablePersonOnlyContacts: [],
    availableLenders: [],
    filteredLenders: [],
    availableLendersPerCountry: [],
    availableLendersDocuments: [],
    availableProducts: [],
    preferredProduct: {},
    preferredLender: {},
    preferredLenderDocument: {},
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    isReady: false
  };

  webpage.pageTitle('Loading, please wait');

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact($scope.sortByIdContacts(contacts));
      if ($scope.Model.availableContacts.length) {
        $scope.Model.availablePersonOnlyContacts = $scope.Model.availableContacts.filter(
          (c) => !c.isCompany
        );
      }
      deferred.resolve(contacts);
    });
    return deferred.promise;
  };

  const loadLenders = (currentTicketOwner) => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry.cca2],
        type: 'RESIDENTIAL'
      })
      .then((lenders) => {
        if (lenders && lenders.length) {
          if ($rootScope.IsEnterprise) {
            const filteredLenderCommissions = _.filter(
              $rootScope.CurrentOrganization.enterprise.lenderCommissions,
              (lc) =>
                lc.upfront !== null &&
                lc.upfront !== undefined &&
                lc.upfront >= 0 &&
                lc.trail !== null &&
                lc.trail !== undefined &&
                lc.trail >= 0
            );
            const availableLenderCommissions = _.map(filteredLenderCommissions, 'id');
            $scope.Model.availableLenders = _.filter(
              lenders,
              (lender) => availableLenderCommissions.indexOf(lender.id) > -1
            );
          } else {
            $scope.Model.availableLenders = lenders;
          }
          const idLenderAccreditations = currentTicketOwner.lenderAccreditations.map(
            (l) => l.idLender
          );
          const idLenders = _.compact(
            _.map(idLenderAccreditations, (p) => {
              if (!_.isUuid(p)) {
                return p;
              }
              return null;
            })
          );
          if (idLenders) {
            $scope.Model.filteredLenders = $scope.Model.availableLenders.filter(
              (l) => idLenders.indexOf(l.id) > -1
            );
            lendersService
              .getDocuments({ idLenders, types: ['LOGO'] })
              .then((lendersDocuments) => {
                if (lendersDocuments?.length) {
                  $scope.Model.availableLendersDocuments = lendersDocuments;
                }
                deferred.resolve(lenders);
              });
          }
        }
      });
    return deferred.promise;
  };

  const loadHomeLoan = (idHomeLoan) => {
    const deferred = $q.defer();
    homeLoanService.readHomeLoan({ id: idHomeLoan }).then((homeLoan) => {
      $scope.Model.currentHomeLoan = homeLoan;
      deferred.resolve(homeLoan);
    });
    return deferred.promise;
  };

  const initialize = () => {
    loadWorkflow();
    loadTicket($stateParams.dd).then(() => {
      webpage.pageTitle($scope.Model.currentTicket.getName());
      loadContacts($scope.Model.currentTicket.idClients).then(() => {
        loadAccount($scope.Model.currentTicket.idOwner).then(() => {
          loadLenders($scope.Model.currentTicketOwner).then(() => {
            if (
              $scope.isDealOwnerBroker() &&
              $scope.Model.hasBrokerToolsEnabled &&
              $scope.Model.filteredLenders.length
            ) {
              if (!$scope.Model.currentTicket.idLoan) {
                $scope.redirectToFactFind();
              } else {
                loadHomeLoan($scope.Model.currentTicket.idLoan).then(() => {
                  $scope.Model.preferredProduct = _.find(
                    $scope.Model.currentHomeLoan?.compareProducts,
                    (p) => p.isPreferred
                  );
                  $scope.Model.preferredLender = $scope.getLender(
                    $scope.Model.preferredProduct?.idLender
                  );
                  $scope.Model.preferredLenderDocument = $scope.getLenderDocument(
                    $scope.Model.preferredProduct?.idLender
                  );
                  $scope.Model.isReady = true;
                });
              }
            } else {
              $scope.redirectToFactFind();
            }
          });
        });
      });
    });
  };

  initialize();

  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.showHomeLoanTools = () =>
    $scope.Model.isReady &&
    $scope.isDealOwnerBroker() &&
    $scope.Model.hasBrokerToolsEnabled &&
    $scope.Model.filteredLenders.length &&
    $scope.Model.currentWorkflow.isHomeLoan();

  $scope.sortByIdContacts = (contacts) => {
    const sortedContacts = [];
    $scope.Model.currentTicket.idClients.forEach((id) => {
      const contact = contacts.find((c) => c.id === id);
      sortedContacts.push(contact);
    });
    return sortedContacts;
  };

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.redirectToFactFind = () => {
    $state.transitionTo('factFind', {
      id: $stateParams.id,
      dd: $stateParams.dd
    });
  };

  $scope.getLender = (idLender) =>
    _.find($scope.Model.filteredLenders, (l) => l.id === idLender);

  $scope.getLenderDocument = (idLender) =>
    _.find($scope.Model.availableLendersDocuments, (d) =>
      d.lender[0] ? d.lender[0].id === idLender && d.type.indexOf('LOGO') > -1 : undefined
    );

  /*
   * Home loan ~ Switch/Refix products
   * --------------------------------------------------------------------------------
   */
  $scope.switchProduct = ($event, idLender, index, amount) => {
    if (idLender) {
      $scope.Model.currentHomeLoan.searchFields.idLenders = [idLender];
      $scope.Model.currentHomeLoan.searchFields.loanAmount = amount || 0;
      const maxLVR = _.max(
        _.map($scope.Model.currentHomeLoan?.fundingWorksheets?.fundsAvailable, 'baseLvr')
      );
      $scope.Model.currentHomeLoan.searchFields.lvr =
        helperService.round({ value: maxLVR }) || 0;
      $scope.saveHomeLoan({
        searchFields: $scope.Model.currentHomeLoan.searchFields
      });
      $mdDialog
        .show({
          targetEvent: $event,
          locals: {
            organizationCountry: $scope.Model.organizationCountry || {},
            preferredProduct: $scope.Model.preferredProduct || {},
            preferredLender: $scope.Model.preferredLender || {},
            preferredLenderDocument: $scope.Model.preferredLenderDocument || {},
            homeLoan: $scope.Model.currentHomeLoan || {},
            idTicket: $scope.Model.currentTicket?.id || '',

            contacts: $scope.Model.availableContacts || [],
            assets: $scope.Model.currentTicket?.assets || [],
            liabilities: $scope.Model.currentTicket?.liabilities || [],
            ticketClientTypes: $scope.Model.currentTicket?.ticketClientTypes || [],
            income: $scope.Model.currentTicket?.income || [],
            expenses: $scope.Model.currentTicket?.expenses || {},
            workflow: $scope.Model.currentWorkflow || {},
            isDealOwnerBroker: $scope.isDealOwnerBroker()
          },
          template,
          controllerAs: '$ctrl',
          controller(
            scope,
            organizationCountry,
            preferredProduct,
            preferredLender,
            preferredLenderDocument,
            homeLoan,
            idTicket,

            contacts,
            assets,
            liabilities,
            ticketClientTypes,
            income,
            expenses,
            workflow,
            isDealOwnerBroker
          ) {
            const ctrl = this;
            ctrl.idx = index;
            ctrl.activeSection = 'search';
            ctrl.organizationCountry = organizationCountry;
            ctrl.preferredProduct = preferredProduct;
            ctrl.product = {};
            ctrl.title = `${
              ctrl.organizationCountry.cca2 === 'NZ' ? 'Refix' : 'Switch'
            } product split: ${ctrl.preferredProduct?.productSplits[index]?.productName}`;
            ctrl.preferredLender = preferredLender;
            ctrl.preferredLenderDocument = preferredLenderDocument;
            ctrl.lenders = [preferredLender];
            ctrl.documents = [preferredLenderDocument];
            ctrl.homeLoan = homeLoan;
            ctrl.idTicket = idTicket;
            ctrl.changedData = '';
            ctrl.reviewProductSplit = {};
            ctrl.compareProductSplit = {};

            ctrl.contacts = contacts;
            ctrl.assets = assets;
            ctrl.liabilities = liabilities;
            ctrl.ticketClientTypes = ticketClientTypes;
            ctrl.income = income;
            ctrl.expenses = expenses;
            ctrl.workflow = workflow;
            ctrl.isDealOwnerBroker = isDealOwnerBroker;

            ctrl.sIdx = -1;
            ctrl.switchProduct = {};
            if (_.isEmpty(ctrl.homeLoan?.switchProducts)) {
              ctrl.homeLoan.switchProducts = {
                switchCompareProducts: [],
                switchReviewProducts: []
              };
            }
            ctrl.switchReviewProduct = SwitchReviewProduct.Blank();
            ctrl.switchCompareProduct = SwitchCompareProduct.Blank();
            ctrl.canApply = true;

            const pRPIdx = _.findIndex(
              ctrl.homeLoan?.reviewProducts || [],
              (p) => p?.isPreferred
            );

            ctrl.showSection = (section) => {
              ctrl.activeSection = section;
            };

            ctrl.saveSearchLoanProducts = (data) => {
              ctrl.saveHomeLoan(data);
            };

            ctrl.productsSelected = (data) => {
              const [reviewProduct, compareProduct] = homeLoanService.addProductToCompare({
                selectedProduct: data
              });

              if (!_.isEmpty(reviewProduct) && !_.isEmpty(compareProduct)) {
                ctrl.switchReviewProduct.productSplits = reviewProduct?.productSplits || [];
                ctrl.switchReviewProduct.productSplits[0].idParent =
                  ctrl.homeLoan?.reviewProducts[pRPIdx]?.productSplits[ctrl.idx]?.id || '';
                ctrl.switchReviewProduct.productSplits[0].commissions = {
                  loanAccountNumber:
                    ctrl.homeLoan?.reviewProducts[pRPIdx]?.productSplits[ctrl.idx]?.commissions
                      ?.loanAccountNumber || '',
                  offsetAccountNumber:
                    ctrl.homeLoan?.reviewProducts[pRPIdx]?.productSplits[ctrl.idx]?.commissions
                      ?.offsetAccountNumber || ''
                };

                ctrl.switchCompareProduct.productSplits = compareProduct?.productSplits || [];
                ctrl.switchCompareProduct.productSplits[0].idParent =
                  ctrl.homeLoan?.compareProducts[pRPIdx]?.productSplits[ctrl.idx]?.id || '';

                ctrl.showSection('review');
              } else {
                ctrl.showSection('search');
              }
            };

            ctrl.canProcessBeFinished = (status) => {
              ctrl.canApply = status;
            };

            ctrl.saveSwitchProduct = (data) => {
              ctrl.switchReviewProduct = SwitchReviewProduct.Build(data?.switchReviewProduct);
              ctrl.switchCompareProduct = SwitchCompareProduct.Build(
                data?.switchCompareProduct
              );
            };

            ctrl.saveHomeLoan = (data) => {
              const homeLoanData = data;
              const hLCD = data?.hLCD || '';
              if (data?.hLCD !== undefined) {
                delete homeLoanData.hLCD;
              }
              homeLoanData.id = ctrl.homeLoan?.id || '';
              if (homeLoanData?.id) {
                homeLoanService.updateHomeLoanPartial(homeLoanData).then(() => {
                  eventService.changedData({ changedData: hLCD });
                });
              }
            };

            ctrl.switchRefixSave = () => {
              $mdDialog.hide({
                switchReviewProduct: ctrl.switchReviewProduct,
                switchCompareProduct: ctrl.switchCompareProduct
              });
            };
            ctrl.cancel = () => {
              $mdDialog.cancel();
            };
          }
        })
        .then((result) => {
          if (result?.switchReviewProduct && result?.switchCompareProduct) {
            const rIdx = _.findIndex(
              $scope.Model.currentHomeLoan.switchProducts.switchReviewProducts,
              (p) => p.isActive === true
            );
            if (rIdx > -1) {
              $scope.Model.currentHomeLoan.switchProducts.switchReviewProducts[
                rIdx
              ].productSplits = $scope.Model.currentHomeLoan.switchProducts.switchReviewProducts[
                rIdx
              ].productSplits.concat(result.switchReviewProduct.productSplits);
            } else {
              $scope.Model.currentHomeLoan.switchProducts.switchReviewProducts.push(
                result.switchReviewProduct
              );
            }
            const cIdx = _.findIndex(
              $scope.Model.currentHomeLoan.switchProducts.switchCompareProducts,
              (p) => p.isActive === true
            );
            if (cIdx > -1) {
              $scope.Model.currentHomeLoan.switchProducts.switchCompareProducts[
                cIdx
              ].productSplits = $scope.Model.currentHomeLoan.switchProducts.switchCompareProducts[
                cIdx
              ].productSplits.concat(result.switchCompareProduct.productSplits);
            } else {
              $scope.Model.currentHomeLoan.switchProducts.switchCompareProducts.push(
                result.switchCompareProduct
              );
            }
            $scope.saveHomeLoan({
              switchProducts: $scope.Model.currentHomeLoan.switchProducts
            });
          }
        });
    } else {
      uiService.toast({
        text: {
          p1: 'There is',
          p2: 'no selected',
          p3: 'lender'
        },
        warn: true
      });
    }
  };

  $scope.switchProductsSave = $mdUtil.debounce((data) => {
    if (data && !_.isEmpty(data)) {
      if (!data?.switchReviewProducts || !data?.switchCompareProducts) {
        $scope.saveHomeLoan({
          switchProducts: {
            switchReviewProducts: [],
            switchCompareProducts: []
          }
        });
      } else {
        $scope.saveHomeLoan({
          switchProducts: {
            switchReviewProducts: data.switchReviewProducts,
            switchCompareProducts: data.switchCompareProducts
          }
        });
      }
    }
  }, 500);

  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.saveHomeLoan = (data) => {
    const homeLoan = data;
    const hLCD = data?.hLCD || '';
    if (data?.hLCD !== undefined) {
      delete homeLoan.hLCD;
    }
    $scope.Model.currentHomeLoan.deleteDateObject();
    homeLoan.id = $scope.Model.currentHomeLoan.id;
    homeLoanService.updateHomeLoanPartial(homeLoan).then((result) => {
      if (result.status) {
        uiService.toast({
          text: {
            p1: 'Home loan for deal',
            p2: $scope.Model.currentTicket.getName(),
            p3: 'has been updated'
          },
          success: true
        });
      }
      eventService.changedData({ changedData: hLCD });
    });
  };
};
